<template>
  <div class="karaoke-container main-image" :style="getMainImg(startGameConfig.mainImage)">
    <div class="game-mz-karaoke">
      <div ref="lyrics" class="lyrics" style="overflow-x: hidden">
        <div
          v-if="ball && !transparentBall && audioStatus"
          :key="ballKey"
          class="ball bouncing-ball"
          :style="bouncingBallStyle"
        ></div>
        <div v-if="synchronized && audioStatus" class="lyrics-bar" :style="barStyle"></div>
        <img
          draggable="false"
          ref="lyricsImage"
          alt="Tekst piosenki"
          class="lyrics-image"
          :style="startGameConfig.image.imgStyle"
          :src="getImageSrc(startGameConfig.image.src)"
          :height="imageHeight"
          :width="imageWidth"
        />
        <div
          v-if="startGameConfig.text"
          style="
            color: black;
            position: absolute;
            top: 0;
            left: 0;
            text-align: left;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 70%;
            overflow-y: auto;
            margin-top: 5%;
          "
          :style="startGameConfig.text.textStyle"
        >
          <div style="height: 100%">
            <p
              class="title"
              :style="startGameConfig.text.titleStyle"
              style="font-weight: bold; font-size: 64px; text-align: center"
              v-html="startGameConfig.text.title"
            ></p>
            <p
              :style="startGameConfig.text.authorStyle"
              class="author"
              style="font-size: 19px"
              v-html="startGameConfig.text.author"
            ></p>
            <div style="margin-top: 64px">
              <p
                :style="startGameConfig.text.lyricsStyle"
                class="lyrics"
                :key="index + '-lyric'"
                style="font-size: 46px; line-height: normal; overflow: hidden"
                v-html="lyric"
                v-for="(lyric, index) in startGameConfig.text.lyrics"
              ></p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="dualMode" class="modes">
        <b-button-group size="lg" class="btn-group">
          <b-button
            v-for="(btn, idx) in buttons"
            @click="changeMode"
            :key="idx"
            :pressed.sync="btn.state"
            variant="primary"
            class="btn-mode text-secondary"
          >
            {{ btn.caption }}
          </b-button>
        </b-button-group>
      </div>
      <div>
        <div v-if="showPlayer" class="audio-wraper" :class="{ 'modal-ui-active': modalActive }" :style="fromBottom">
          <div class="audio" :style="audioPlayerStyle(startGameConfig.audioPlayer)">
            <audio id="playerAudio" :style="`--plyr-color-main: ${playerColor}`" controls crossorigin playsinline>
              <source :src="audioFile" type="audio/ogg" />
              <source :src="audioFile" type="audio/mpeg" :key="componentKey" />
              Your browser does not support the audio element.
            </audio>
          </div>
          <div v-if="showTitle" class="title-test">{{ this.$store.getters.gameData.centerBar }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Plyr from 'plyr';

import { getAudioURL } from '__mainSrcDir/Utils/DB/get';
import { AUDIO_NAMES } from '__mainSrcDir/Utils/DB/configDB';
// import store from '__mainSrcDir/store';
export default {
  name: 'mz-karaoke',
  props: {
    /**
     * object startGameConfig
     * @param  {Object} mainImage  object startGameConfig.audioPlayer
     * @param  {Object} mainImage.imagePath   path to background image
     * @param  {Object} mainImage.cssStyle    css3 style object apply to .mainImage class (main game container
     *                                        if you change height or width all elements will change)
     * @param  {Object} audioPlayer           object startGameConfig.audioPlayer
     * @param  {Object} audioPlayer.cssStyle  css3 style object apply to .audio class
     */
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      buttons: [
        { caption: 'Wersja wokalna', state: true },
        { caption: 'Wersja instrumentalna', state: false },
      ],
      audioFile: '',
      componentKey: true,
      dualMode: false,
      showPlayer: true,
      destroyAudio: false,
      ball: true,
      ballDiameter: 12,
      ballColor: 'rgba(255, 255, 0, 1)',
      transparentBall: true,
      ballKey: false,
      synchronized: false,
      showTitle: false,
      imageHeight: 1027,
      imageWidth: 1280,
      threshold: 127,
      inverted: false,
      topBarOffset: 5,
      bottomBarOffset: 5,
      leftBarOffset: 5,
      leftBarOffsetOr0: 0,
      rightBarOffset: 5,
      rightBarOffsetOr0: 0,
      spaceFactor: 65,
      duration: 0.2,
      jumpHeight: 35,
      scrollRealHeight: 0,
      leftBallPosition: 0,
      centerBallPosition: 0,
      rightBallPosition: 0,
      bottomFirstBallPosition: 0,
      bottomSecondBallPosition: 0,
      topBallPosition: 0,
      ballPosition: -1,
      ballStyleTop: 0,
      trace: [],
      lyrics: [],
      barStyle: {},
      audioSettings: {},
      player: {},
      audioStatus: false,
      playerColor: '#00b3ff',
    };
  },
  methods: {
    audioPlayerStyle(item) {
      if (item) {
        return this.getCustomStyle(item);
      }
      return {};
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    getMainImg(mainImg) {
      if (mainImg && mainImg.imagePath) {
        return {
          ...{
            backgroundImage: `url('${this.getImageSrc(mainImg.imagePath)}')`,
          },
          ...this.getCustomStyle(mainImg),
        };
      }
      return this.getCustomStyle(mainImg);
    },
    getImageSrc(imageSrc) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${imageSrc}`);
    },
    changeAudio(_name) {
      // console.log('CLICK');
      let name = _name;
      if (!name) {
        name = _.sample(AUDIO_NAMES);
      }
      return getAudioURL(name).then((audioURL) => {
        this.audioFile = audioURL;
        this.forceRerender();
      });
    },
    forceRerender() {
      this.componentKey = !this.componentKey;
    },
    move(c, c2) {
      if (this.lyrics.length != 0) {
        this.barStyle.left = this.$refs.lyricsImage.offsetLeft + this.lyrics[c].left - this.leftBarOffsetOr0 + 'px';
        this.barStyle.width = this.lyrics[c].width + this.leftBarOffsetOr0 + this.rightBarOffsetOr0 + 'px';
        if (this.lyrics[c].top - this.topBarOffset > this.scrollRealHeight) {
          this.$refs.lyrics.scrollTop = this.scrollRealHeight;
          this.barStyle.top =
            this.$refs.lyricsImage.offsetTop + this.lyrics[c].top - this.topBarOffset - this.scrollRealHeight + 'px';
          this.ballStyleTop =
            this.$refs.lyricsImage.offsetTop + this.lyrics[c2].top - this.topBarOffset - this.scrollRealHeight;
        } else {
          this.barStyle.top = this.$refs.lyricsImage.offsetTop + this.lyrics[1].top - this.topBarOffset + 'px';
          this.ballStyleTop = this.$refs.lyricsImage.offsetTop + this.lyrics[1].top - this.topBarOffset;
          this.$refs.lyrics.scrollTop = this.lyrics[c].top - this.lyrics[1].top;
        }
        this.bottomFirstBallPosition = this.ballStyleTop - this.$refs.lyricsImage.offsetTop - this.ballDiameter + 'px';
        this.topBallPosition =
          this.ballStyleTop - this.jumpHeight - this.$refs.lyricsImage.offsetTop - this.ballDiameter + 'px';
        this.bottomSecondBallPosition = this.ballStyleTop - this.$refs.lyricsImage.offsetTop - this.ballDiameter + 'px';
        let totalOffset = 0;
        if (c > 0 && c < this.trace[this.trace.length - 1]) {
          this.transparentBall = false;
          if (this.lyrics[c2].ball != this.ballPosition) {
            this.ballPosition = this.lyrics[c2].ball;
            this.leftBallPosition =
              this.$refs.lyricsImage.offsetLeft + this.lyrics[c2 - 1].ball - this.ballDiameter / 2 + 'px';
            this.centerBallPosition =
              this.$refs.lyricsImage.offsetLeft +
              this.lyrics[c2 - 1].ball +
              (this.lyrics[c2].ball - this.lyrics[c2 - 1].ball) / 2 -
              this.ballDiameter / 2 +
              'px';
            this.rightBallPosition =
              this.$refs.lyricsImage.offsetLeft + this.lyrics[c2].ball - this.ballDiameter / 2 + 'px';
            this.ballKey = !this.ballKey;
          }
          totalOffset = this.topBarOffset + this.bottomBarOffset;
        }
        if (c2 >= this.trace[this.trace.length - 1]) {
          this.transparentBall = true;
        }
        this.barStyle.height = this.lyrics[c].height + totalOffset + 'px';
      }
    },
    setSource(src) {
      this.player.source = {
        type: 'audio',
        sources: [
          {
            src: require(`__staticDir/${this.$store.getters.multibookType}/${src}`),
            type: 'audio/mp3',
          },
          {
            src: require(`__staticDir/${this.$store.getters.multibookType}/${src}`),
            type: 'audio/ogg',
          },
        ],
      };
    },
    changeMode(event) {
      if (event.target.innerText == 'Wersja wokalna') {
        this.setSource(this.startGameConfig.audio.src);
        this.buttons[0].state = true;
        this.buttons[1].state = false;
      } else {
        this.setSource(this.startGameConfig.audio.src2);
        this.buttons[0].state = false;
        this.buttons[1].state = true;
      }
    },
    loadImage(file, w, h) {
      return new Promise((resolve, reject) => {
        let cnv = document.createElement('canvas'),
          img = new Image(),
          ctx = cnv.getContext('2d');
        cnv.width = w;
        cnv.height = h;
        img.src = this.getImageSrc(file);
        img.addEventListener('load', () => {
          ctx.drawImage(img, 0, 0);
        });
        img.onload = () => resolve(ctx.getImageData(0, 0, w, h));
        img.onerror = () => reject(console.log('Error loading image'));
      });
    },
    lines(image) {
      let gray = 255,
        isLetter = false,
        width4 = image.width * 4,
        result = [{ top: 0, height: 0 }];
      for (let i = 0; i < image.data.length; i += 4) {
        gray = Math.ceil(image.data[i] * 0.3 + image.data[i + 1] * 0.59 + image.data[i + 2] * 0.11);
        if (!this.inverted) {
          if (gray <= this.threshold) {
            if (!isLetter) {
              result.push({ top: ~~(i / width4), height: null });
              isLetter = true;
            }
            i = (~~(i / width4) + 1) * width4;
          }
        } else {
          if (gray > this.threshold) {
            if (!isLetter) {
              result.push({ top: ~~(i / width4), height: null });
              isLetter = true;
            }
            i = (~~(i / width4) + 1) * width4;
          }
        }
        if (isLetter && i == (~~(i / width4) + 1) * width4 - 4) {
          isLetter = false;
          result[result.length - 1].height = ~~(i / width4) - result[result.length - 1].top;
        }
      }
      if (result[result.length - 1].height === null) {
        result[result.length - 1].height = image.height - result[result.length - 1].top;
      }
      result.push({ top: this.imageHeight, height: 0 });
      return result;
    },
    words(image, lines) {
      let gray = 255,
        isWord = false,
        h = 0,
        p = 0,
        result = [{ top: 0, height: 0, left: 0, width: 0 }];
      for (let i = 1; i < lines.length - 1; i++) {
        for (let j = 0; j < image.width * 4; j += 4) {
          h = 0;
          while (h < lines[i].height) {
            p = lines[i].top * image.width * 4 + h * image.width * 4 + j;
            gray = Math.ceil(image.data[p] * 0.3 + image.data[p + 1] * 0.59 + image.data[p + 2] * 0.11);
            if (!this.inverted) {
              if (gray <= this.threshold) {
                if (!isWord) {
                  result.push({ top: lines[i].top, height: lines[i].height, left: j / 4, width: null });
                  isWord = true;
                }
                break;
              }
            } else {
              if (gray > this.threshold) {
                if (!isWord) {
                  result.push({ top: lines[i].top, height: lines[i].height, left: j / 4, width: null });
                  isWord = true;
                }
                break;
              }
            }
            h++;
          }
          if (isWord && h == lines[i].height) {
            isWord = false;
            result[result.length - 1].width = j / 4 - result[result.length - 1].left;
          }
        }
      }
      if (result[result.length - 1].width === null) {
        result[result.length - 1].width = image.width - result[result.length - 1].left;
      }
      result.push({ top: this.imageHeight, height: 0, left: 0, width: 0 });
      return result;
    },
    getLyrics(words) {
      let result = [{ top: 0, height: 0, left: 0, width: 0 }];
      words.forEach((e) => {
        if (e.top == result[result.length - 1].top) {
          result[result.length - 1].width = e.left - result[result.length - 1].left + e.width;
        } else {
          result.push({ top: e.top, height: e.height, left: e.left, width: e.width });
        }
      });
      return result;
    },
    getLyricsWithLimit(words, limit) {
      let result = [{ top: 0, height: 0, left: 0, width: 0 }],
        minLeft = 0;
      words.forEach((e) => {
        if (e.top == result[result.length - 1].top) {
          if (e.left - (result[result.length - 1].left + result[result.length - 1].width) >= limit) {
            result.push({ top: e.top, height: e.height, left: e.left, width: e.width });
          } else {
            result[result.length - 1].width = e.left - result[result.length - 1].left + e.width;
          }
        } else {
          result.push({ top: e.top, height: e.height, left: e.left, width: e.width });
        }
      });
      return result.map((e, i, a) => {
        if (a[i - 1] !== undefined && e.top != a[i - 1].top) {
          minLeft = e.left;
        }
        return {
          top: e.top,
          height: e.height,
          left: minLeft,
          width: e.width + e.left - minLeft,
          ball: ~~(e.width / 2) + e.left,
        };
      });
    },
    findSpace(words) {
      let val = 0;
      return words.reduce((prev, curr) => {
        val = prev.space;
        if (prev.top == curr.top) {
          val = curr.left - (prev.left + prev.width);
          if (prev.space !== undefined && prev.space > val) {
            val = prev.space;
          }
        }
        return { top: curr.top, height: curr.height, left: curr.left, width: curr.width, space: val };
      }).space;
    },
  },
  computed: {
    audio() {
      return this.$store.getters.audioData;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
    bouncingBallStyle() {
      return {
        '--diameter': this.ballDiameter + 'px',
        '--duration': this.duration + 's',
        '--left': this.leftBallPosition,
        '--center': this.centerBallPosition,
        '--right': this.rightBallPosition,
        '--bottom-first': this.bottomFirstBallPosition,
        '--top': this.topBallPosition,
        '--bottom-second': this.bottomSecondBallPosition,
        '--ball-color': this.ballColor,
      };
    },
    fromBottom() {
      return { '--b': this.showTitle ? 35 + '%' : 0 + '%' };
    },
  },
  created() {
    if (this.$store.getters.gameData.centerBar) {
      this.showTitle = true;
    }
    if ('height' in this.startGameConfig.image) {
      this.imageHeight = this.startGameConfig.image.height;
    }
    if ('width' in this.startGameConfig.image) {
      this.imageWidth = this.startGameConfig.image.width;
    }
    if ('threshold' in this.startGameConfig.image) {
      this.threshold = this.startGameConfig.image.threshold;
    }
    if ('inverted' in this.startGameConfig.image) {
      this.inverted = this.startGameConfig.image.inverted;
    }
    if ('spaceFactor' in this.startGameConfig.image) {
      this.spaceFactor = this.startGameConfig.image.spaceFactor;
    }
    if ('isVisible' in this.startGameConfig.audio) {
      this.showPlayer = false;
    }
    if ('topBarOffset' in this.startGameConfig.bar) {
      this.topBarOffset = this.startGameConfig.bar.topBarOffset;
    }
    if ('bottomBarOffset' in this.startGameConfig.bar) {
      this.bottomBarOffset = this.startGameConfig.bar.bottomBarOffset;
    }
    if ('leftBarOffset' in this.startGameConfig.bar) {
      this.leftBarOffset = this.startGameConfig.bar.leftBarOffset;
    }
    if ('rightBarOffset' in this.startGameConfig.bar) {
      this.rightBarOffset = this.startGameConfig.bar.rightBarOffset;
    }
    if ('duration' in this.startGameConfig.ball) {
      this.duration = this.startGameConfig.ball.duration;
    }
    if ('jumpHeight' in this.startGameConfig.ball) {
      this.jumpHeight = this.startGameConfig.ball.jumpHeight;
    }
    if ('diameter' in this.startGameConfig.ball) {
      this.ballDiameter = this.startGameConfig.ball.diameter;
    }
    if ('color' in this.startGameConfig.ball) {
      this.ballColor = this.startGameConfig.ball.color;
    }
    if ('audioPlayer' in this.startGameConfig && 'color' in this.startGameConfig.audioPlayer) {
      this.playerColor = this.startGameConfig.audioPlayer.color;
    }
    this.loadImage(this.startGameConfig.image.src, this.imageWidth, this.imageHeight).then((image) => {
      let words = this.words(image, this.lines(image));
      if ('division' in this.startGameConfig.image && this.startGameConfig.image.division == 'line') {
        this.ball = false;
        this.lyrics = this.getLyrics(words);
        this.leftBarOffsetOr0 = this.leftBarOffset;
        this.rightBarOffsetOr0 = this.rightBarOffset;
      } else {
        this.lyrics = this.getLyricsWithLimit(words, Math.round(this.findSpace(words) * (this.spaceFactor / 100)));
        this.lyrics[0].ball = this.lyrics[1].left;
        this.leftBarOffsetOr0 = this.leftBarOffset;
        this.rightBarOffsetOr0 = this.rightBarOffset;
      }
      return this.lyrics;
    });
  },
  mounted() {
    if ('settings' in this.startGameConfig.audio) {
      this.synchronized = true;
      this.barStyle = this.startGameConfig.bar.cssStyle;
      this.scrollRealHeight = this.$refs.lyrics.scrollHeight - this.$refs.lyrics.offsetHeight;
      if (this.scrollRealHeight <= 0) {
        this.scrollRealHeight = 0;
      }
      this.audioSettings = this.startGameConfig.audio.settings;
      this.trace = new Array(this.startGameConfig.audio.length + Math.round(this.duration * 100));
      for (let i = 0, c = 1; i < this.trace.length; i++) {
        if (c < this.audioSettings.length && i >= this.audioSettings[c].timeStamp) {
          c++;
        }
        this.trace[i] = this.audioSettings[c - 1].id;
      }
    }
    if ('src2' in this.startGameConfig.audio) {
      this.dualMode = true;
    }
    console.log('MOUNT AUDIO');
    const controls = ['play', 'restart', 'progress', 'current-time', 'mute', 'volume', 'settings'];
    this.player = new Plyr('#playerAudio', { controls });
    if (process.env.VUE_PWA) {
      console.log('PWA working');
      options.mp3 = require(`__staticDir/${this.$store.getters.multibookType}/${this.startGameConfig.audio.src}`);
      console.log('options', options);
      this.changeAudio(options.mp3);
    } else {
      this.setSource(this.startGameConfig.audio.src);
    }
    let ts = 0,
      shift = Math.round(this.duration * 100);
    if (this.synchronized) {
      this.player.on('timeupdate', (event) => {
        ts = Math.round(event.detail.plyr.currentTime * 100);
        if (!this.destroyAudio) {
          this.move(this.trace[ts], this.trace[ts + shift]);
        }
      });
      this.player.on('play', () => {
        this.audioStatus = true;
      });
      this.player.on('pause', () => {
        this.audioStatus = false;
      });
      this.player.on('ended', () => {
        this.audioStatus = false;
      });
    }
  },
  beforeDestroy: function () {
    console.log('Destroy Plyr audio');
    this.$store.commit('GALLERY_DEACTIVATE');
    this.destroyAudio = true;
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/songButtons';
.karaoke-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
}
.game-mz-karaoke {
  width: 100%;
  height: 88%;
}
.ball {
  position: absolute;
  z-index: 3;
}
.ball:after {
  content: '';
  display: block;
  width: var(--diameter);
  height: var(--diameter);
  border-radius: var(--diameter);
  background-image: radial-gradient(farthest-side at 35% 45%, var(--ball-color), rgba(33, 33, 0, 0.4));
}
.bouncing-ball {
  animation-name: xAxis;
  animation-duration: var(--duration);
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
}
.bouncing-ball::after {
  animation-name: yAxis;
  animation-duration: var(--duration);
  animation-iteration-count: 1;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;
}
@keyframes xAxis {
  0% {
    transform: translateX(var(--left));
  }
  50% {
    animation-timing-function: ease-out;
    transform: translateX(var(--center));
  }
  100% {
    transform: translateX(var(--right));
  }
}
@keyframes yAxis {
  0% {
    transform: translateY(var(--bottom-first));
  }
  50% {
    animation-timing-function: ease-in;
    transform: translateY(var(--top));
  }
  100% {
    transform: translateY(var(--bottom-second));
  }
}
.lyrics-bar {
  z-index: 2;
}
.lyrics-image {
  z-index: 1;
}
.lyrics {
  z-index: 0;
  margin-top: 5%;
  width: 100%;
  overflow: auto;
  max-height: 80%;
}
.modes {
  margin-top: 1%;
  position: absolute;
  z-index: 2;
  width: 100%;
  font-size: 0.5em;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn-group {
  width: 30%;
}
.btn-mode {
  width: 50%;
}
.audio-wraper {
  position: absolute;
  bottom: var(--b);
  z-index: 1;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 20%;
  .audio {
    display: block;
    width: 60%;
    height: auto;
    // position: relative;
    #playerAudio {
      width: 100%;
    }
  }
}
.title-text {
  position: absolute;
  margin-top: 60px;
}
/**change base white color to light grey */
.plyr--audio .plyr__controls {
  background: #e6e6e6 !important;
}
.plyr__menu__container {
  background: rgba(#e6e6e6, 0.9);
}
.main-img {
  z-index: -1;
  position: fixed;
  object-fit: cover;
}
</style>
